var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuPush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5378_1683)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 35.5,
    fill: "#161618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3718 36.2478L37.3439 50.6251C36.8037 51.5188 36.0221 52 35.2193 52C34.8955 52 34.5679 51.9216 34.2527 51.7608C33.0961 51.1723 32.5359 49.6695 32.9223 48.186L34.4278 41.0008H29.6386C28.2881 41.0008 27.0576 40.1855 26.4249 38.8738C25.7922 37.5622 25.871 35.9824 26.6287 34.7546L34.6541 20.3746C35.4132 19.1207 36.6461 18.6793 37.7465 19.2389C38.9032 19.8274 39.4634 21.3301 39.077 22.8137L37.5702 30.0002L42.3632 30.0044C43.7124 30.0044 44.9429 30.8197 45.5756 32.1313C46.2071 33.4416 46.1296 35.0214 45.3718 36.2492V36.2478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3718 36.2478L37.3439 50.6251C36.8037 51.5188 36.0221 52 35.2193 52C34.8955 52 34.5679 51.9216 34.2527 51.7608C33.0961 51.1723 32.5359 49.6695 32.9223 48.186L34.4278 41.0008H29.6386C28.2881 41.0008 27.0576 40.1855 26.4249 38.8738C25.7922 37.5622 25.871 35.9824 26.6287 34.7546L34.6541 20.3746C35.4132 19.1207 36.6461 18.6793 37.7465 19.2389C38.9032 19.8274 39.4634 21.3301 39.077 22.8137L37.5702 30.0002L42.3632 30.0044C43.7124 30.0044 44.9429 30.8197 45.5756 32.1313C46.2071 33.4416 46.1296 35.0214 45.3718 36.2492V36.2478Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5378_1683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPush);
export default __webpack_public_path__ + "static/media/menu-push.7d5af8742107561255d2a7e5e98606b9.svg";
export { ForwardRef as ReactComponent };